




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

@Component
export default class TBody extends Vue {
	private showRowMenuIdx: number = -1;

	@Prop() private columns!: any;
	@Prop() private rows!: any;
	@Prop() private tableState!: string;

	@State private splitData!: boolean;
	@State private totalRows!: number;

	@Action private goTo!: any;
	@Action private deleteRow!: any;

	private isLink(text: string) {
		if (text !== undefined && text !== null) {
			// // too slow
			// // Regular Expression for URL validation
			// //
			// // Author: Diego Perini
			// // Created: 2010/12/05
			// // Updated: 2018/09/12
			// // License: MIT
			// //
			// var linkRegex = new RegExp(
			//   "^" +
			//     // protocol identifier (optional)
			//     // short syntax // still required
			//     "(?:(?:(?:https?|ftp):)?\\/\\/)" +
			//     // user:pass BasicAuth (optional)
			//     "(?:\\S+(?::\\S*)?@)?" +
			//     "(?:" +
			//       // IP address exclusion
			//       // private & local networks
			//       "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
			//       "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
			//       "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
			//       // IP address dotted notation octets
			//       // excludes loopback network 0.0.0.0
			//       // excludes reserved space >= 224.0.0.0
			//       // excludes network & broadcast addresses
			//       // (first & last IP address of each class)
			//       "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
			//       "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
			//       "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
			//     "|" +
			//       // host & domain names, may end with dot
			//       // can be replaced by a shortest alternative
			//       // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
			//       "(?:" +
			//         "(?:" +
			//           "[a-z0-9\\u00a1-\\uffff]" +
			//           "[a-z0-9\\u00a1-\\uffff_-]{0,62}" +
			//         ")?" +
			//         "[a-z0-9\\u00a1-\\uffff]\\." +
			//       ")+" +
			//       // TLD identifier name, may end with dot
			//       "(?:[a-z\\u00a1-\\uffff]{2,}\\.?)" +
			//     ")" +
			//     // port number (optional)
			//     "(?::\\d{2,5})?" +
			//     // resource path (optional)
			//     "(?:[/?#]\\S*)?" +
			//   "$", "i"
			// );

			// if (text.match(linkRegex)) {
			// 	return true;
			// } 
			if (text.includes('http://') || text.includes('https://')) {
				return true;
			}
		}
		
		return false;
	}

	private getType(colKey: number) {
		return this.columns.find((col: any) => col.key === colKey).type;
	}

	private get columnKeys() {
		return this.columns.map((col: any) => {
			if (col !== undefined) {
				return col.key;
			} else {
				return '';
			}
		});
	}

	private shortenLink(colData: string) {
		const MAX_LENGTH = 40;
		if (colData === null) { return ' '; }
		if (colData.length > MAX_LENGTH) {
			return colData.substr(0, MAX_LENGTH) + '...';
		}
		return colData;
	}

	private getRowColData(row: any, colKey: string) {
		return (row !== null && row[colKey]) ? row[colKey].data : ' ';
	}
}
